/**
 * Whitelisted internal same-user conversions (legacy asset-swap subset).
 * Each pair is 1:1 on `amount`. Extend only with schema + policy review.
 */
import type { TokenId } from './tokens.js';

export const INTERNAL_CONVERT_PAIRS: ReadonlyArray<readonly [TokenId, TokenId]> = [
  // ── EP family ─────────────────────────────────────────────────────
  ['ep', 'ep1'],   // EP → EP1 (冻结一期)
  ['ep1', 'ep'],   // EP1 → EP (解冻)
  ['ep', 'ep2'],   // EP → EP2 (冻结二期)
  ['ep2', 'ep'],   // EP2 → EP (解冻)

  // ── EP reinvestment (locked) ──────────────────────────────────────
  ['ep1', 'sp1'],  // EP1 → SP1 (分裂池一)
  ['ep2', 'sp2'],  // EP2 → SP2 (分裂池二)

  // ── RP reinvestment (one-way; no sp3→rp) ─────────────────────────
  ['rp', 'sp3'],   // RP → SP3 (分裂池三)

  // ── RP → AP (算力→活动积分，用于晋级捐币；走 /api/level-upgrade/rp-ap-orb) ─
  ['rp', 'ap'],

  // ── EP → RP (算力积分变换) ────────────────────────────────────────
  ['ep', 'rp'],    // EP → RP

  // ── FC (分红币 / ORB燃料) ─────────────────────────────────────────
  ['fc', 'uo'],    // FC → UO (分红币兑换源石)
  ['fp', 'fc'],    // FP → FC (分红积分兑换分红币)
  ['rp', 'fc'],    // RP → FC (算力积分购买燃料，1:1)

  // ── UOC mint: EP1/EP2 → UOC (1:1) ────────────────────────────────
  ['ep1', 'uoc'],
  ['ep2', 'uoc'],

  // ── UOC burn: UOC → RP/TP/EP (rate-controlled via UocConfig) ─────
  ['uoc', 'rp'],
  ['uoc', 'tp'],
  ['uoc', 'ep'],

  // ── Withdrawal paths (record only — actual payout handled off-chain) ─
  ['rp', 'uo'],    // RP → UO (算力兑换源石)
  ['tp', 'uo'],    // TP → UO (贡献兑换源石)
];

export function isInternalConvertPair(from: TokenId, to: TokenId): boolean {
  return INTERNAL_CONVERT_PAIRS.some(([a, b]) => a === from && b === to);
}
